<template>
    <div id="print" class="big_cat_screen"  @touchmove="touchmove" :style="{'background-color': '#365ba4'}">
        <div v-if="!isEmpty(listCourseQuestion)">
            <div class="back_nav" @click="goToBack"><img src="@/assets/back_nav.png"/></div>
            <div class="right_comefrom" @click="comefromClick" v-if="currentCourseQuestion != null && !isEmpty(currentCourseQuestion.pageNumber)">
                <img src="@/assets/help_outline.png"/>
                <span>本题来源</span>
            </div>
            <div class="transition" v-if="showTransition">
                <div class="back_nav2" v-on:click.stop="gameQuitClick"><img src="@/assets/back_nav.png"/></div>
                <div class="content">
                    <div class="content2">
                        <img class="icon" src="@/Images/jili.png"/>
                        <div id="id_star_count" class="text">
                            <span class="success_tip">祝贺完成!</span>
                        </div>
                        <div class="content3">
                            <div class="transition_comeback" v-on:click.stop="gameQuitClick">
                                <img src="@/Images/transition_comeback.png"/>
                            </div>
                            <div class="transition_next" v-on:click.stop="nextPageClick">
                                <span>{{courseId === 1 ? "Worksheets" : "Mind Map"}}</span>
                                <img src="@/assets/chevron-thin-right.png"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <audio class="audio" :src="greatAudio" id="great_audio" @ended="playEnded('great_audio')" @error="playEnded('great_audio')"/>

            <div v-if="showExitConfirm === 1" class="exit_transition">
                <div class="exit_content">
                    <div class="exit_title">还没有完成，确认要放弃吗？</div>
                    <div class="game_action">
                        <div class="game_quit" v-on:click.stop="gameQuitClick">
                            <img src="@/Images/game_quit.png"/>
                            <span>Quit</span>
                        </div>
                        <div class="game_continue" v-on:click.stop="gameContinueClick">
                            <img src="@/Images/game_continue.png"/>
                            <span>Continue</span>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="isPlayingFail" class="playing_fail" @click="playCAudio()">
                <img src="@/Images/icon_replay.png" />
            </div>

            <!-- 题目 -->
            <div class="c_question_content" @click="playCAudio()">
                <div class="c_audio_play">
                    <div class="audio_playing_game img_play" :style="{display: isPlaying ? '' : 'none'}"></div>
                    <img class="img_play" :style="{display: isPlaying ? 'none' : ''}" src="@/Images/audio_game3.png" height="40px" width="40px"/>
                </div>
                <div class="c_content">{{currentCourseQuestion.text}}</div>
            </div>

            <!-- 选项 -->
            <div class="option_main">
                <div class="c_option">
                    <!-- 类型(1文字题/2图片题)-->
                    <template v-if="currentCourseQuestion.type === 1">
                        <div class="c_option_text">
                            <div :id="'ww_option_' + index" class="c_option_text_item" v-for="(item,index) in currentCourseQuestion.optionArray" :key="index">
                                <div class="c_audio_play" @click="playOptionAudio(index)">
                                    <div class="audio_playing_game img_play" :style="{display: isOptionPlaying && clickOptionIndex === index ? '' : 'none'}"></div>
                                    <img class="img_play" :style="{display: isOptionPlaying && clickOptionIndex === index ? 'none' : ''}" src="@/Images/audio_game3.png"/>
                                </div>
                                <div class="c_option_text_itemcontent" @click="optionClick(item, index)">
                                    <div class="serial_number">{{getTextSerialNumber(index)}}</div>
                                    <div class="text_content">{{item.text}}</div>
                                    <div class="clear"></div>
                                    <div :id="'ww_error_' + index" class="w_error"><img src="@/Images/cuowu.png" height="24px" width="24px"/></div>
                                    <div :id="'ww_success_' + index" class="w_success"><img src="@/Images/zhengque.png" height="24px" width="24px"/></div>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="c_option_item" v-for="(item,index) in currentCourseQuestion.optionArray" :key="index">
                            <div class="c_option_img_item" @click="optionClick(item, index)">
                                <img :class="item.pictureWidth === item.pictureHeight ? 'lazy_img1' : 'lazy_img'" v-lazy="$qiNiuDomainBase + item.picture" />
                                <div :id="'cc_error_' + index" :class="item.pictureWidth === item.pictureHeight ? 'c_error1' : 'c_error'"><img src="@/assets/error.png"/></div>
                                <div :id="'cc_success_' + index" :class="item.pictureWidth === item.pictureHeight ? 'c_success1' : 'c_success'"><img src="@/assets/success.png"/></div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
            <mt-popup v-model="popupVisible" popup-transition="popup-fade" class="mint-popup-1" :style="{ top:'83px', right:'-40px', left:'auto'}">
                <div class="popup_content">
                    <div class="popup_title">到对应页找答案</div>
                    <div class="popup_answer">
                        <a v-for="(item,index) in getPageNumberArray(currentCourseQuestion.pageNumber)"
                           :key="index" @click="pageNumberClick(item)">{{getPageNumberString(item, index, getPageNumberCount(currentCourseQuestion.pageNumber))}}</a>
                    </div>
                </div>
            </mt-popup>
            <audio v-show="false" :src="ccAudioUrl" id="cc_musicMp3" @ended="endQuestionAudio()" @error="endQuestionAudio()" />
            <audio v-show="false"  id="option_musicMp3" @ended="endOptionAudio()" @error="endOptionAudio()" />

            <audio class="audio" :src="ccErrorAudio" id="cc_error_audio" style="display: none" @ended="playEnded('cc_error_audio')" @error="playEnded('cc_error_audio')" controls=""/>
            <audio class="audio" :src="ccSuccessAudio" id="cc_success_audio" style="display: none" @ended="playEnded('cc_success_audio')" @error="playEnded('cc_success_audio')" controls=""/>
            <div class="common_question_left" @click="handBackQuestionClick" style="display: none"><img src="@/assets/question_left.png"/></div>
            <div class="common_question_right" @click="handNextQuestion"><img src="@/assets/question_right.png"/></div>
        </div>
    </div>

</template>

<script>
    import $ from "jquery";
    import Utils from "@/pages/Program/util2";

    function transformView() {
        var width = document.documentElement.clientWidth;
        var height = document.documentElement.clientHeight;

        var vPrint =  $('#print');
        if( width > height ){
            //竖屏
            vPrint.width(width);
            vPrint.height(height);
            vPrint.css('top', 0);
            vPrint.css('left', 0);
            vPrint.css('transform' , 'none');
            vPrint.css('transform-origin' , '50% 50%');
            $(".dp_question_sty img").css("height", "calc(100vh - 60px)");
        }
        else{
            //横屏
            vPrint.width(height);
            vPrint.height(width);
            vPrint.css('top',  (height-width)/2 );
            vPrint.css('left',  0-(height-width)/2 );
            vPrint.css('transform' , 'rotate(90deg)');
            vPrint.css('transform-origin' , '50% 50%');
            $(".dp_question_sty img").css("height", "calc(100vw - 60px)");
        }
    }

    export default {
        name: "pchoicequestion",
        data() {
            return {
                courseId: 1,
                lessonId: 0,
                questionIndex: 0,
                listCourseQuestion: [],
                currentCourseQuestion:null,
                ccErrorAudio: "https://img.xiaohuasheng.cn/error_tip.mp3",
                ccSuccessAudio: "https://img.xiaohuasheng.cn/success.mp3",
                ccAudioUrl: "",
                showExitConfirm: 0,
                showStarTransition:false,
                showTransition:false,
                questionAudioEnd:0,
                successIndex:0,
                isPlaying: false,
                isPlayingFail: false,
                isOptionPlaying: false,
                clickOptionIndex: 0,
                popupVisible: false,
                greatAudio:"https://img.xiaohuasheng.cn/great.mp3",
            }
        },
        methods: {
            goToBack() {
                this.showExitConfirm = 1;
            },
            comefromClick() {
                this.popupClick();
            },
            popupClick() {
                this.popupVisible = true;
            },
            closePopup:function() {
                this.popupVisible = false;
            },
            pageNumberClick(pageNumber) {
                this.closePopup();
                this.isPlaying = false;

                localStorage.setItem('bfchoicequestion_questionIndex', this.questionIndex + "");
                localStorage.setItem('bfchoicequestion_questionJson', JSON.stringify(this.listCourseQuestion));
                this.removePageWordLocalStorage();
                // 本题来源
                this.$router.push({name: "BFPageWord", query: {lessonId: this.lessonId, courseId: this.courseId, pageNumber: pageNumber}});
            },
            getPageNumberArray(pageNumber) {
                if (this.isEmpty(pageNumber)) {
                    return [];
                }

                return pageNumber.split(",");
            },
            getPageNumberCount(pageNumber) {
              let pageNumberArray = this.getPageNumberArray(pageNumber);
              return pageNumberArray.length;
            },
            getPageNumberString(PageNumber, index, count) {
                if (index + 1 === count) {
                    return PageNumber;
                }

                return PageNumber + ",";
            },
            getTextSerialNumber(index) {
                if (index === 0) {
                    return "A";
                }

                if (index === 1) {
                    return "B";
                }

                if (index === 2) {
                    return "C";
                }
            },
            touchmove(e) {
                e.preventDefault();
            },
            playEnded(idMusicmp3) {
                var musicMp3 = document.getElementById(idMusicmp3);

                if (musicMp3 != null) {
                    musicMp3.pause();
                }
            },
            playEndedForNext(idMusicmp3) {
                this.playEnded(idMusicmp3);
                this.isPlaying = false;

                if (this.questionAudioEnd === 1) {
                    this.questionAudioEnd = 0;
                    $("#cc_success_" + this.successIndex).hide();
                    this.successIndex = 0;
                    this.autoNextQuestion();
                }
            },
            gameQuitClick() {
                this.showExitConfirm = 0;
                this.removeChoicequestionLocalStorage();
                this.$router.go(-1);
            },
            nextPageClick() {
                if (this.courseId === 1) {
                    this.$router.replace({
                        name: 'BFExpansion', query: {lessonId: this.lessonId}
                    });
                } else {
                    this.$router.replace({
                        name: 'BFMindMap2', query: {lessonId: this.lessonId}
                    });
                }
            },
            gameContinueClick() {
                this.showExitConfirm = 0;
            },
            getStateHeight: function () {
                return this.getCount(this.$store.state.statusheight);
            },
            playErrorAudio() {
                const ccErrorAudio = document.getElementById('cc_error_audio');
                ccErrorAudio.play();
            },
            playSuccessAudio() {
                const ccSuccessAudioPlay = document.getElementById('cc_success_audio');
                ccSuccessAudioPlay.play();
            },
            optionClick:function(objQuestionOption, index){
                let that = this;

                if (that.questionAudioEnd === 1) {
                    return;
                }

                let isRightAnswer = that.getCount(objQuestionOption.isRightAnswer);

                // 0不是正确答案/1是正确答案
                if (isRightAnswer === 0) {
                    that.playErrorAudio();

                    // 类型(1文字题/2图片题)
                    if (that.currentCourseQuestion.type === 1) {
                        $("#ww_option_" + index).find(".c_option_text_itemcontent").css('background-color' , 'red');
                        $("#ww_option_" + index).find(".text_content").css('color' , 'white');
                        $("#ww_error_" + index).show();

                        setTimeout(function () {
                            $("#ww_option_" + index).find(".c_option_text_itemcontent").css('background-color' , 'white');
                            $("#ww_option_" + index).find(".text_content").css('color' , 'black');
                            $("#ww_error_" + index).hide();
                        }, 500);
                    } else {
                        $("#cc_error_" + index).show();

                        setTimeout(function () {
                            $("#cc_error_" + index).hide();
                        }, 500);
                    }

                    return;
                }

                that.playSuccessAudio();
                // 类型(1文字题/2图片题)
                if (that.currentCourseQuestion.type === 1) {
                    $("#ww_option_" + index).find(".c_option_text_itemcontent").css('background-color' , '#0DBF02');
                    $("#ww_option_" + index).find(".text_content").css('color' , 'white');
                    $("#ww_success_" + index).show();
                } else {
                    $("#cc_success_" + index).show();
                }

                // 过2.3秒跳转到下一步
                setTimeout(function () {
                    if (that.currentCourseQuestion.type === 1) {
                        $("#ww_option_" + index).find(".c_option_text_itemcontent").css('background-color' , 'white');
                        $("#ww_option_" + index).find(".text_content").css('color' , 'black');
                        $("#ww_success_" + index).hide();
                    }

                    that.questionAudioEnd = 1;
                    that.successIndex = index;
                    that.playEndedForNext('cc_musicMp3');
                }, 2300);
            },
            handBackQuestionClick:function() {
                let that = this;

                that.questionAudioEnd = 0;
                $("#cc_success_" + that.successIndex).hide();
                that.successIndex = 0;
                that.questionIndex -= 1;

                // 返回按钮
                if (that.questionIndex <= 0) {
                    $(".common_question_left").hide();
                } else {
                    $(".common_question_left").show();
                }

                // 下一步按钮
                if (that.questionIndex >= that.listCourseQuestion.length - 1) {
                    $(".common_question_right").hide();
                } else {
                    $(".common_question_right").show();
                }

                that.initData();
            },
            handNextQuestion() {
                this.questionAudioEnd = 0;
                $("#cc_success_" + this.successIndex).hide();
                this.successIndex = 0;
                this.autoNextQuestion();
            },
            autoNextQuestion() {
                let that = this;
                that.nextQuestionClick();
            },
            nextQuestionClick: function () {
                let that = this;
                that.questionIndex += 1;
                that.initLeftAndRightStyle();

                if (that.questionIndex >= that.listCourseQuestion.length) {
                    that.showFinishTransition();
                    // 1读前拓展/2概念词汇/3逐页听读/4读后练习
                    Utils.$emit('setBigCat5Finished', that.lessonId, 4);
                    return;
                }

                that.initData();
            },
            initLeftAndRightStyle() {
                let that = this;

                // 返回按钮
                if (that.questionIndex <= 0) {
                    $(".common_question_left").hide();
                } else {
                    $(".common_question_left").show();
                }

                // 下一步按钮
                if (that.questionIndex >= that.listCourseQuestion.length - 1) {
                    $(".common_question_right").hide();
                } else {
                    $(".common_question_right").show();
                }
            },
            initData:function () {
                let that = this;

                that.currentCourseQuestion = that.listCourseQuestion[that.questionIndex];
                that.ccAudioUrl = "";
                window.console.log(JSON.stringify("题目类型：" + that.currentCourseQuestion.type))

                if (!that.isEmpty(that.currentCourseQuestion.audio)) {
                    that.ccAudioUrl = that.$qiNiuDomainBase + that.currentCourseQuestion.audio;

                    setTimeout(() => {
                        that.playCAudio();
                    }, 200);
                }
            },
            showFinishTransition() {
                let that = this;
                that.showTransition = true;

                const greatAudio = document.getElementById('great_audio');
                greatAudio.play();
            },
            playCAudio() {
                let that = this;
                that.endOptionAudio();

                if (that.isEmpty(that.ccAudioUrl)) {
                    return;
                }

                that.isPlayingFail = false;
                let ccmusicMp3 = document.getElementById('cc_musicMp3');
                ccmusicMp3.src = that.ccAudioUrl;
                that.isPlaying = true;

                setTimeout(() => {
                    let playPromise = ccmusicMp3.play();

                    if (playPromise !== undefined) {
                        playPromise.then(() => {
                        }).catch((e) => {
                            let vError = JSON.stringify(e);
                            that.isPlayingFail = true;

                            if (!that.isEmpty(vError) && vError !== "{}") {
                                that.isPlaying = false;
                                window.console.log("播放失败:playAudio:" + JSON.stringify(e));
                            }
                        });
                    } else {
                        that.isPlaying = false;
                        window.console.log("播放失败:playAudio");
                    }
                }, 300);
            },
            playOptionAudio(index) {
                let that = this;
                let vOption = that.currentCourseQuestion.optionArray[index];
                that.endQuestionAudio();
                that.endOptionAudio();

                let vAudioUrl = that.$qiNiuDomainBase + vOption.audio;
                window.console.log(vAudioUrl);

                if (that.isEmpty(vAudioUrl)) {
                    return;
                }

                let optionMusicMp3 = document.getElementById('option_musicMp3');
                optionMusicMp3.src = vAudioUrl;
                that.clickOptionIndex = index;
                that.isOptionPlaying = true;

                setTimeout(() => {
                    let playPromise = optionMusicMp3.play();

                    if (playPromise !== undefined) {
                        playPromise.then(() => {
                        }).catch((e) => {
                            let vError = JSON.stringify(e);

                            if (!that.isEmpty(vError) && vError !== "{}") {
                                that.isOptionPlaying = false;
                                window.console.log("播放失败:playAudio:" + JSON.stringify(e));
                            }
                        });
                    } else {
                        that.isOptionPlaying = false;
                        window.console.log("播放失败:playAudio");
                    }
                }, 300);
            },
            endQuestionAudio() {
                let that = this;
                that.isPlaying = false;
                that.playEnded('cc_musicMp3');
            },
            endOptionAudio() {
                let that = this;
                that.clickOptionIndex = 0;
                that.isOptionPlaying = false;
                that.playEnded('option_musicMp3');
            },
            hideStatusAndStopAudio: function () {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    document.location = "readingclubapp:hideStatusAndStopAudio";
                }

                if (vPlatform === 4) {
                    window.note.hideStatusAndStopAudio();
                }
            },
            judgePlatform: function () {
                let that = this;
                // 平台（0-其它平台 1-微信IOS平台 2-微信android平台 3-app平台IOS平台 4-app平台android平台）
                let Platform = 0;
                let token = that.$store.state.token;
                let userid = that.$store.state.userid.toString();

                if (that.isWeixinBrowser()) {
                    // 微信平台
                    if (that.isAppIos()) {
                        Platform = 1;
                    } else {
                        Platform = 2;
                    }
                } else if (!that.isEmpty(token) && !that.isEmpty(userid) && token.length > userid.length) {
                    // app平台
                    if (that.isAppIos()) {
                        Platform = 3;
                    } else {
                        Platform = 4;
                    }
                } else {
                    Platform = 0;
                }

                return Platform;
            },
            initCreate(aytoPlay) {
                let that = this;
                that.hideStatusAndStopAudio();

                if (that.currentCourseQuestion != null) {
                    if (that.isEmpty(that.currentCourseQuestion.audio)) {
                        that.ccAudioUrl = "";
                    } else {
                        that.ccAudioUrl = that.$qiNiuDomainBase + that.currentCourseQuestion.audio;

                        if (aytoPlay) {
                            setTimeout(() => {
                                that.playCAudio();
                            }, 200);
                        }
                    }
                }

                setTimeout(() => {
                    if (!aytoPlay) {
                        transformView();
                    }

                    that.initLeftAndRightStyle();
                }, 50);
            }
        },
        created() {
            let that = this;

            if (localStorage == null) {
                return;
            }

            let strquestionIndex = localStorage.getItem('bfchoicequestion_questionIndex');
            let jsonCourseQuestions = localStorage.getItem('bfchoicequestion_questionJson');

            if (!that.isEmpty(jsonCourseQuestions) && !that.isEmpty(strquestionIndex)) {
                let vLessonId = parseInt(that.$route.query.lessonId);
                let vCourseId = that.getCount(this.$route.query.courseId);
                that.listCourseQuestion = JSON.parse(jsonCourseQuestions);

                that.questionIndex = that.getCount(strquestionIndex);

                that.currentCourseQuestion = that.listCourseQuestion[that.questionIndex];
                that.lessonId = vLessonId;
                that.courseId = vCourseId;
                that.initCreate(false);
            }
        },
        beforeCreate() {
            let that = this;

            if (localStorage != null) {
                let strquestionIndex = localStorage.getItem('bfchoicequestion_questionIndex');
                let jsonCourseQuestions = localStorage.getItem('bfchoicequestion_questionJson');

                if (jsonCourseQuestions !== null && jsonCourseQuestions.length > 0
                    && strquestionIndex !== null && strquestionIndex.length > 0) {
                    return;
                }
            }

            let vLessonId = parseInt(that.$route.query.lessonId);
            let vCourseId = that.getCount(this.$route.query.courseId);
            let url = "/bigCat6/getReadingComprehensionQuestion/" + vLessonId;

            setTimeout(() => {
                transformView();
            }, 50);

            that.$axios.get(url).then((response) => {
                that.listCourseQuestion = response.data;
                window.console.log(JSON.stringify(response.data))
                that.currentCourseQuestion = that.listCourseQuestion[that.questionIndex];
                that.courseId = vCourseId;
                that.lessonId = vLessonId;

                that.initCreate(true);
            }).catch(function (error) {
                window.console.log(error)
            });
        }
    }
</script>

<style scoped>
    @media screen and (orientation: portrait) {
        html {
            width: 100%;
            height: 100%;
            background-color: white;
            overflow: hidden;
        }

        body {
            width: 100%;
            height: 100%;
            background-color: red;
            overflow: hidden;
        }

        #print {
            position: absolute;
            background-color: #f2f2f2;
        }
    }

    @media screen and (orientation: landscape) {
        html {
            width: 100%;
            height: 100%;
            background-color: white;
        }

        body {
            width: 100%;
            height: 100%;
            background-color: white;
        }

        #print {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: #f2f2f2;
        }
    }

    img { pointer-events: none; }

    .big_cat_screen {
        -webkit-user-select:none;
        -khtml-user-select:none;
        -moz-user-select:none;
        -ms-user-select:none;
    }
    .back_nav {
        position: absolute;
        z-index: 999;
        left: 15px;
        top: 15px;
        width: 45px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .back_nav img {
        width: 30px;
        height: 30px;
    }

    .right_comefrom {
        position: absolute;
        z-index: 999;
        right: 15px;
        top: 15px;
        width: 100px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .right_comefrom span {
        font-size: 15px;
        color: white;
        margin-left: 2px;
    }
    .right_comefrom img {
        width: 20px;
        height: 20px;
    }

    .option_main {
        position: absolute;
        width: 100%;
        bottom: 30px;
    }
    .c_option {
        margin-left: calc((100vmax - 100vmin)/3);
        margin-right: calc((100vmax - 100vmin)/3);
        display: flex;
        justify-content: space-between;
    }
    .c_option .c_option_text {
        width: 100%;
        background-color: #c8cfde;
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        padding: 6px 16px 16px 16px;
    }
    .c_option .c_option_text_item {
        display: inline-flex;
        position: relative;
        width: 100%;
    }
    .c_option .c_option_img_item {
        display: inline-flex;
        position: relative;
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
    }
    .c_option .c_option_text_item .c_option_text_itemcontent {
        position: relative;
        border: 1px solid #f2b940;
        height: 51px;
        width: 100%;
        margin-top: 10px;
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        display: flex;
        align-items: center;
        background-color: white;
    }
    .c_option .c_option_text_item .c_option_text_itemcontent .serial_number {
        float: left;
        background-color: #f2b940;
        color: white;
        font-size: 17px;
        height: 51px;
        width: 36px;
        line-height: 51px;
        text-align: center;
        border-bottom-left-radius:10px;
        border-top-left-radius: 10px;
        -webkit-border-bottom-left-radius: 10px;
        -webkit-border-top-left-radius: 10px;
        -moz-border-radius-bottomleft: 10px;
        -moz-border-radius-topleft: 10px;
    }
    .c_option .c_option_text_item .c_option_text_itemcontent .text_content {
        float: left;
        width: calc(100% - 46px - 20px);
        margin-left: 5px;
        font-size: 18px;
        font-weight: bold;
    }
    .c_option .c_option_text_item .c_option_text_itemcontent .w_error {
        display: none;
        position: absolute;
        right: 10px;
        height: 24px;
        top:50%;
        -webkit-transform: translateY(-50%);
    }
    .c_option .c_option_text_item .c_option_text_itemcontent .w_success {
        display: none;
        height: 24px;
        position: absolute;
        right: 10px;
        top:50%;
        -webkit-transform: translateY(-50%);
    }
    .c_option .c_option_img_item .lazy_img {
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        width: 36vmin;
        height: 42vmin;
    }
    .c_option .c_option_img_item .lazy_img1 {
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        width: 36vmin;
        height: 36vmin;
    }
    .c_option_img_item .c_error {
        position: absolute;
        bottom: 0;
        background-color: rgba(0,0,0,0.5);
        width: 36vmin;
        height: 42vmin;
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        display: none;
    }
    .c_option_img_item .c_error1 {
        position: absolute;
        bottom: 0;
        background-color: rgba(0,0,0,0.5);
        width: 36vmin;
        height: 36vmin;
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        display: none;
    }
    .c_option_img_item .c_error img, .c_option_img_item .c_error1 img {
        position: absolute;
        width: 50%;
        height: auto;
        top: 50%;
        left: 50%;
        -webkit-transform: translateX(-50%) translateY(-50%);
    }
    .c_option_img_item .c_success {
        position: absolute;
        background-color: rgba(47,205,0,0.8);
        width: 36vmin;
        height: 42vmin;
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        display: none;
    }
    .c_option_img_item .c_success1 {
        position: absolute;
        background-color: rgba(47,205,0,0.8);
        width: 36vmin;
        height: 36vmin;
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        display: none;
    }
    .c_option_img_item .c_success img, .c_option_img_item .c_success1 img {
        position: absolute;
        width: 50%;
        height: auto;
        top: 50%;
        left: 50%;
        -webkit-transform: translateX(-50%) translateY(-50%);
    }

    .c_question_content {
        position: absolute;
        display: flex;
        align-items: center;
        max-width: calc(100vmax/3.0 + 200vmin/3.0);
        min-height: 20vmin;
        padding-bottom: 5px;
        padding-top: 5px;
        top: 40px;
        margin-left: calc((100vmax - 100vmin)/3);
        background-color: #00000039;
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
    }
    .c_question_option {

    }
    .c_option_text_item .c_audio_play .img_play {
        width: 30px;
        height: 30px;
    }
    .c_option_text_item  .c_audio_play {
        margin-top: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 16px;
    }
    .c_question_content .c_audio_play .img_play {
        width: 40px;
        height: 40px;
    }
    .c_question_content .c_audio_play {
        position: relative;
        display: flex;
        z-index:600;
        margin-left: 20px;
    }
    .c_question_option .c_audio_play {
        position: relative;
        display: flex;
        z-index:600;
        justify-content: center;
        align-items: center;
    }
    .c_question_content .c_audio_play img, .c_question_option .c_audio_play img {
        width: 40px;
        height: 40px;
    }
    .c_question_content .c_content {
        position: relative;
        z-index:599;
        min-width: 60vmin;
        line-height: 22px;
        padding-top: 1px;
        padding-bottom: 1px;
        /*display: flex;*/
        /*align-items: center;*/
        padding-left: 10px;
        padding-right: 30px;
        font-size: 20px;
        color: white;
        font-family: Arial, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Verdana, Roboto, Noto, Helvetica Neue, sans-serif;
    }
    .big_cat_screen .exit_transition {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.9);
        z-index: 1003;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .big_cat_screen .exit_content {
        position:relative;
    }
    .big_cat_screen .exit_content .exit_title {
        color: white;
        font-size: 18px;
        text-align: center;
        margin-bottom: 50px;
    }
    .big_cat_screen .exit_content .game_action .game_quit {
        display: inline-block;
        margin-right: 100px;
    }
    .big_cat_screen .exit_content .game_action .game_continue {
        display: inline-block;
    }
    .big_cat_screen .exit_content .game_action .game_quit img, .big_cat_screen .exit_content .game_action .game_continue img {
        display: block;
        width: 70px;
        margin-bottom: 10px;
    }
    .big_cat_screen .exit_content .game_action .game_quit span, .big_cat_screen .exit_content .game_action .game_continue span {
        display: block;
        text-align: center;
        font-size: 20px;
        color: white;
    }
    .big_cat_screen .transition {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.85);
        z-index: 1002;
    }
    .big_cat_screen .transition .content {
        position: relative;
        z-index: 1001;
        width: 100%;
        height: 100vmin;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .big_cat_screen .transition .content2 {
        text-align: center;
    }

    .big_cat_screen .transition .content3 {
        text-align: center;
    }
    .big_cat_screen .transition .content .icon {
        margin-bottom: 10px;
        width: 35%;
    }
    .big_cat_screen .transition .content .text {
        width: 100%;
        margin-top: 5px;
    }
    .big_cat_screen .transition .content .text span {
        display: block;
        text-align: center;
    }
    .big_cat_screen .transition .content .text .success_tip {
        font-size: 24px;
    }
    .big_cat_screen .transition .content .star {
        height: 35px;
    }
    .big_cat_screen .transition .content .star .star_item {
        width: 35px;
        height: 35px;
        display: inline-block;
        position: relative;
    }
    .big_cat_screen .transition .content .star .star_item img {
        width: 35px;
        height: 35px;
        display: none;
        position: absolute;
        left:50%;
        top: 50%;
        -webkit-transform: translateX(-50%) translateY(-50%);
    }
    .big_cat_screen .transition .content .text span {
        width: 100%;
        color: white;
        font-size: 12px;
    }
    .transition_next {
        margin-top: 30px;
        display: inline-block;
        background-color: #07A745;
        width: 140px;
        height: 40px;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        vertical-align: middle;
        animation: zoom 1s infinite;
        text-align: center;
    }
    .transition_next span {
        display: inline-block;
        font-size: 16px;
        color: white;
        line-height: 39px;
        vertical-align: middle;
    }
    .transition_next img {
        display: inline-block;
        width: 15px;
        vertical-align: middle;
    }
    .transition_comeback {
        margin-top: 30px;
        margin-right: 25px;
        display: inline-block;
        text-align: center;
        vertical-align: middle;
        font-size: 0;
    }
    .transition_comeback img {
        display: inline-block;
        width: 40px;
        height: 40px;
    }
    .back_nav2 {
        position: absolute;
        z-index: 1003;
        left: 15px;
        top: 15px;
        width: 45px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .back_nav2 img {
        width: 30px;
        height: 30px;
    }
    .navigation .left i {
        background-color: #0000005a;
        border-radius: 22px;
        font-size: 18px;
        padding: 5px;
    }

    .mint-popup-1 {
        width: 124px;
        border-radius: 8px;
        padding: 10px;
    }

    .mint-popup-1::before {
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-bottom: 8px solid #fff;
        content: '';
        position: absolute;
        top: -6px;
        right: 10px;
    }

    .popup_content {
    }

    .popup_content .popup_title {
        font-size: 10px;
        color: #A0A0A0;
        text-align: center;
    }

    .popup_content .popup_answer {
        margin-top: 3px;
        text-align: center;
    }

    .popup_content .popup_answer a {
        font-size: 15px;
        color: #21639a;
    }

</style>
